<div class="tag-box" data-testid="tag-box">
    <div class="tag-box__pills" *ngIf="tags.length > 0">
        <ham-tag-pill
            *ngFor="let tag of tags; trackBy: trackById"
            data-testid="tag-pill"
            [attr.data-selected]="isSelected(tag._id) ? 'true' : 'false'"
            [label]="tag.name"
            [selected]="isSelected(tag._id)"
            [highlighted]="tag._id === pendingDeleteId"
            [clickable]="true"
            [removable]="true"
            [removeAriaLabel]="local.aumico_tags_box_delete_aria | i18next"
            (pillClick)="toggle(tag._id)"
            (removeClick)="requestDelete(tag._id)"
        ></ham-tag-pill>
    </div>

    <!-- Tag in use: ask before deleting (prototype `Tag warnung.png`). The tag name is user input and
         is placed next to the translated text, never passed into i18next. -->
    <div class="tag-box__warning" data-testid="tag-delete-warning" *ngIf="showDeleteWarning" role="alert">
        <span class="tag-box__warning-text"
            >«{{ pendingDeleteTag?.name }}»
            {{
                local.aumico_tags_box_delete_warning
                    | i18next: { companies: usage.usage.companiesCount, persons: usage.usage.personsCount }
            }}</span
        >
        <div class="tag-box__warning-actions">
            <ham-button variant="white" size="sm" (buttonClick)="cancelDelete()">{{
                local.aumico_tags_box_cancel | i18next
            }}</ham-button>
            <ham-button variant="red" size="sm" data-testid="tag-delete-confirm" (buttonClick)="confirmDelete()">{{
                local.aumico_tags_box_delete | i18next
            }}</ham-button>
        </div>
    </div>

    <div class="tag-box__create">
        <input
            hamInput
            class="tag-box__input"
            data-testid="tag-new-input"
            [(ngModel)]="newTagName"
            [ngModelOptions]="{ standalone: true }"
            placeholder="{{ local.aumico_tags_box_new_tag_placeholder | i18next }}"
            (keydown.enter)="$event.preventDefault(); submitNewTag()"
        />
        <ham-button variant="teal" [outline]="true" lucideIcon="plus" data-testid="tag-create" [disabled]="!canCreate" (buttonClick)="submitNewTag()">{{
            local.aumico_tags_box_create | i18next
        }}</ham-button>
    </div>
</div>
